import React, { useContext, useState, useEffect } from 'react';
import { FaShoppingCart, FaBell, FaHeart, FaLightbulb, FaShoppingBasket, FaTrash } from "react-icons/fa";
import { aviso } from "../../../assets/images/index";
import { UserConfigContext } from "../../../context/UserConfigContext";
import { useLocation } from 'react-router-dom';
import { useSelector } from "react-redux";
import DataTable from 'react-data-table-component';
import { formatPrice } from "../../../constants/funciones";
import { eliminaRelacionado, grabaRelacionado, loadProducts, notices, paginationItems } from "../../../constants/products";
import { useFavorites } from "../../../context/FavoritesContext";
import Swal from 'sweetalert2';
import { FaCircleNodes, FaCircleDollarToSlot } from 'react-icons/fa6';
import PriceConsultationButton from "../../common/PriceConsultationButton";

const ProductTable = ({ products, handleImageClick, handleQuantityChange, handleAddToCart, onProductsRefresh }) => {
  const location = useLocation();
  const isNewsPage = location.pathname === "/News" || location.pathname === "/Offer";
  const products2 = useSelector((state) => state.orebiReducer.products);
  const { ensureFavoritesLoaded, isFavorite, toggleFavorite } = useFavorites();
  const { config1, configEcommerce } = useContext(UserConfigContext);
  const contactEmailsSource = config1?.config_ecommerce?.emails_contactos || configEcommerce?.emails_contactos || [];
  const contactEmails = (Array.isArray(contactEmailsSource) ? contactEmailsSource : String(contactEmailsSource).split(/[;,]/))
    .map((email) => typeof email === "string" ? email.trim() : email?.email || email?.mail || email?.correo)
    .filter(Boolean);
  const loggedUserData = JSON.parse(localStorage.getItem("user"));
  const userType = loggedUserData?.data?.empresas?.[0]?.tipo;
  const userPerfil = loggedUserData?.data?.empresas?.[0]?.perfil;
  const canManageRelations = userType === "a" || userPerfil === "4000";
  const [quantities, setQuantities] = useState({});
  const [previousQuantities, setPreviousQuantities] = useState({});

  const [selectedRow, setSelectedRow] = useState(null);
  const [showRelacionarModal, setShowRelacionarModal] = useState(false);
  const [showProdxCantModal, setShowProdxCantModal] = useState(false);

  const [relacionSearchTerm, setRelacionSearchTerm] = useState("");
  const [relacionResults, setRelacionResults] = useState([]);
  const [loadingRelacionSearch, setLoadingRelacionSearch] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const initialQuantities = products.reduce((acc, product) => {
      const matchedProduct = products2.find((p) => p.codigo === product.codigo);
      acc[product.codigo] = matchedProduct
        ? Math.min(Number(matchedProduct.quantity) || 0, Math.max(0, Number(product.Stock) || 0))
        : 0;
      return acc;
    }, {});
    setQuantities(initialQuantities);
    setPreviousQuantities(initialQuantities);
  }, [products, products2]);

  useEffect(() => {
    if (products.length === 0 || !Array.isArray(products)) return;

    const loggedUserData = JSON.parse(localStorage.getItem("user"));

    if (loggedUserData?.data?.user?.id) {
      ensureFavoritesLoaded();
    }
  }, [products, ensureFavoritesLoaded]);

  const handleStockAlertClick = (codigo) => {
    // Obt\u00e9n el usuario desde localStorage
    const loggedUserData = JSON.parse(localStorage.getItem("user"));

    const userId = loggedUserData?.data?.user?.id; // Obt\u00e9n el ID del usuario

    Swal.fire({
      title: 'Notificarme Ingreso de Stock',
      text: '¿Queres que te notifiquemos cuando haya stock disponible?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.isConfirmed) {

        notices(codigo, userId, "0")
          .then(data => {
            Swal.fire('¡Listo!', 'Te notificaremos cuando haya stock.', 'success');
          })
          .catch(error => {
            Swal.fire('Error', 'Hubo un problema al procesar la notificacion.', 'error');
          });
      }
    });
  };

  const handleQuantityChangeInternal = (codigo, newQuantity) => {
    const product = products.find((item) => item.codigo === codigo);
    const stock = Math.max(0, Number(product?.Stock) || 0);
    const quantity = Math.min(Math.max(0, Number(newQuantity) || 0), stock);
    setQuantities(prevQuantities => ({
      ...prevQuantities,
      [codigo]: quantity,
    }));
    handleQuantityChange(codigo, quantity);
  };

  const handleAddToCartInternal = (product) => {
    const { codigo } = product;
    const stock = Math.max(0, Number(product.Stock) || 0);
    if (stock <= 0) return;
    const currentQuantity = quantities[codigo] || 0;
    const previousQuantity = previousQuantities[codigo] || 0;

    // Comprobamos si la cantidad ha cambiado
    if (currentQuantity === previousQuantity) {
      // Si no se cambi\u00f3 la cantidad, incrementar en 1
      const updatedQuantity = Math.min(currentQuantity + 1, stock);
      setQuantities((prev) => ({ ...prev, [codigo]: updatedQuantity }));
      setPreviousQuantities((prev) => ({ ...prev, [codigo]: updatedQuantity }));

      // Llamamos a handleAddToCart con la cantidad actualizada
      handleAddToCart(product, updatedQuantity);
    } else {
      // Si se cambi\u00f3, usamos la cantidad actual
      setPreviousQuantities((prev) => ({ ...prev, [codigo]: currentQuantity }));

      // Llamamos a handleAddToCart con la cantidad actual
      handleAddToCart(product, Math.min(currentQuantity, stock));
    }
  };

  const showPriceConsultationModal = () => {
    Swal.fire({
      icon: "info",
      title: "Precio a consultar",
      text: contactEmails.length
        ? `Comuníquese con nosotros a: ${contactEmails.join(", ")}`
        : "Comuníquese con nosotros para consultar el precio.",
      confirmButtonText: "Entendido",
    });
  };

  const handleRelacionar = (product) => {
    // console.log(product.productos_relacionados)
    setSelectedRow(product);
    setRelacionSearchTerm("");
    setRelacionResults([]);
    setShowRelacionarModal(true);

  };

  const handlProdxCant = (product) => {
    // console.log(product.productos_relacionados)
    setSelectedRow(product);
    setShowProdxCantModal(true);

  };

  useEffect(() => {
    if (!showRelacionarModal || !selectedRow) return;

    const searchText = relacionSearchTerm.trim();
    if (searchText.length < 2) {
      setRelacionResults([]);
      return;
    }

    const handler = setTimeout(async () => {
      setLoadingRelacionSearch(true);
      try {
        await loadProducts(1, 10, searchText, 0, 0, 0, 0);
        setRelacionResults(
          paginationItems.filter((product) => product.codigo !== selectedRow.codigo)
        );
      } catch (error) {
        console.error("Error buscando productos para relacionar:", error);
        setRelacionResults([]);
      } finally {
        setLoadingRelacionSearch(false);
      }
    }, 350);

    return () => clearTimeout(handler);
  }, [relacionSearchTerm, selectedRow, showRelacionarModal]);

  useEffect(() => {
    if (!showRelacionarModal) return;

    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setShowRelacionarModal(false);
        setShowProdxCantModal(false);
      }
    };

    window.addEventListener("keydown", handleEscape);
    return () => window.removeEventListener("keydown", handleEscape);
  }, [showRelacionarModal]);

  const handleSelectRelacionado = async (relatedProduct) => {
    if (!selectedRow || !relatedProduct) return;

    const alreadyRelated = selectedRow.productos_relacionados?.some(
      (relacion) => relacion.codigo === relatedProduct.codigo
    );

    if (alreadyRelated) {
      Swal.fire("Producto ya relacionado", "Ese producto ya esta relacionado con el producto seleccionado.", "info");
      return;
    }

    const result = await Swal.fire({
      title: "Relacionar productos",
      html: `Vas a relacionar <b>${relatedProduct.codigo}</b> con <b>${selectedRow.codigo}</b>.`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Relacionar",
      cancelButtonText: "Cancelar",
    });

    if (!result.isConfirmed) return;

    try {
      await grabaRelacionado(selectedRow.codigo, relatedProduct.codigo);
      setSelectedRow((prev) => ({
        ...prev,
        productos_relacionados: [
          ...(prev.productos_relacionados || []),
          {
            codigo_master: prev.codigo,
            codigo: relatedProduct.codigo,
            Descripcion: relatedProduct.Descripcion,
            img: relatedProduct.img,
            simbolo: relatedProduct.simbolo,
            PrecioLista: relatedProduct.PrecioLista,
            PrecioOferta: relatedProduct.PrecioOferta,
            datos_adicionales: relatedProduct.datos_adicionales,
            color_oferta: relatedProduct.color_oferta,
          },
        ],
      }));
      setRelacionSearchTerm("");
      setRelacionResults([]);
      await onProductsRefresh?.();
      Swal.fire("Listo", "Producto relacionado correctamente.", "success");
    } catch (error) {
      Swal.fire("Error", error.message || "No se pudo relacionar el producto.", "error");
    }
  };

  const handleDeleteRelacionado = async (relacion) => {
    if (!selectedRow || !relacion) return;

    const codigoRelacionado = relacion.codigo || relacion.codigo_relacionado;
    const result = await Swal.fire({
      title: "Eliminar relacion",
      html: `Vas a eliminar la relacion entre <b>${selectedRow.codigo}</b> y <b>${codigoRelacionado}</b>.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#dc2626",
    });

    if (!result.isConfirmed) return;

    try {
      await eliminaRelacionado(selectedRow.codigo, codigoRelacionado);
      setSelectedRow((prev) => ({
        ...prev,
        productos_relacionados: (prev.productos_relacionados || []).filter(
          (item) => (item.codigo || item.codigo_relacionado) !== codigoRelacionado
        ),
      }));
      await onProductsRefresh?.();
      Swal.fire("Listo", "Relacion eliminada correctamente.", "success");
    } catch (error) {
      Swal.fire("Error", error.message || "No se pudo eliminar la relacion.", "error");
    }
  };

  const getStockMessageColor = (stockMensaje) => {
    const message = String(stockMensaje || "").toLowerCase();
    if (message.includes("agotado") || message.includes("sin stock")) return "#dc2626";
    if (message.includes("bajo") || message.includes("poco") || message.includes("limitado")) return "#f59e0b";
    return "#16a34a";
  };

  const mostrarStockYMensaje = userType === 'a' || (userType === 'o' && userPerfil === '4000');

  const columns = [
    {
      name: 'Foto',
      width: '72px',
      cell: row => (
        <img
          src={row.img}
          alt={row.Descripcion}
          className="object-contain cursor-pointer"
          style={{ width: '40px', height: '40px' }}
          onClick={() => handleImageClick(row)}
        />
      ),
    },
    {
      name: <div style={{ width: '100%', textAlign: 'left' }}>Código</div>,
      width: '118px',
      cell: row => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            height: '100%',
            cursor: 'pointer',
            width: '100%',
            textAlign: 'left',
            fontSize: '10px',
          }}
          onClick={() => handleImageClick(row)}
        >
          {row.codigo}
        </div>
      ),
      sortable: true,
      sortFunction: (a, b) => {
        // Convierte los valores a n\u00fameros si es posible
        const aValue = isNaN(a.codigo) ? a.codigo : parseFloat(a.codigo);
        const bValue = isNaN(b.codigo) ? b.codigo : parseFloat(b.codigo);

        // Si ambos son n\u00fameros, los comparamos num\u00e9ricamente
        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return aValue - bValue;
        }

        // Si son cadenas de texto, usamos localeCompare
        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return aValue.localeCompare(bValue);
        }

        // Si son diferentes tipos (un nÃºmero y una cadena), los comparamos como texto
        return String(aValue).localeCompare(String(bValue));
      },
    },
    {
      name: <div style={{ width: '100%' }}>Descripción</div>,
      cell: row => {
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              width: '100%',
              justifyContent: 'space-between',
              gap: '8px',
            }}
          >
            <span
              style={{
                flex: 1,
                minWidth: 0,
                width: '100%',
                cursor: 'pointer',
              }}
              onClick={() => handleImageClick(row)}
            >
              {row.Descripcion}
            </span>
            {isFavorite(row.codigo) && (
              <FaHeart
                title='Mi Favorito'
                style={{
                  cursor: 'pointer',
                  color: 'green',
                  marginLeft: '8px',
                }}
                onClick={() => toggleFavorite(row)}
              />
            )}
          </div>
        );
      },
      sortable: true,
      wrap: true,
      grow: 1.8,
      sortFunction: (a, b) => {
        const aValue = isNaN(a.Descripcion) ? a.Descripcion : parseFloat(a.Descripcion);
        const bValue = isNaN(b.Descripcion) ? b.Descripcion : parseFloat(b.Descripcion);

        if (typeof aValue === 'number' && typeof bValue === 'number') {
          return aValue - bValue;
        }

        if (typeof aValue === 'string' && typeof bValue === 'string') {
          return aValue.localeCompare(bValue);
        }

        return String(aValue).localeCompare(String(bValue));
      },
    }
    ,
    {
      name: <div style={{ textAlign: 'right', width: '100%' }}>IVA</div>,
      width: '64px',
      selector: row => row.iva,
      cell: row => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            height: '100%',
            textAlign: 'right',
            width: '100%',
          }}
        >
          {row.iva}
        </div>
      ),
    },
    {
      name: <div style={{ textAlign: 'right', width: '100%' }}>Precio</div>,
      width: '112px',
      cell: row => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'flex-end',
            textAlign: 'right',
            width: '100%',
            height: '100%',
          }}
        >
          {configEcommerce?.ocultar_precio || Number(row.ocultar_precio) === 1 ? (
            <PriceConsultationButton
              className="precio-oculto rounded bg-amber-100 px-2 py-1 text-xs font-bold"
            >
              {row.ocultar_precio_texto || "Precio a consultar"}
            </PriceConsultationButton>
          ) : (
            <>
              <span
                className="precio-lista"
                style={{
                  textDecoration: row.PrecioOferta > 0 ? 'line-through' : 'none',
                  fontSize: '12px',
                }}
              >
                {row.simbolo} {formatPrice(row.PrecioLista || 0)}
              </span>

              {row.PrecioOferta > 0 && (
                <div>
                  <span
                    className="precio-oferta"
                    style={{
                      fontWeight: 'bold',
                      fontSize: '12px',
                      display: 'block',
                      marginTop: '2px',
                    }}
                  >
                    {row.simbolo} {formatPrice(row.PrecioOferta || 0)}
                  </span>
                </div>
              )}
            </>
          )}
        </div>
      ),
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const priceA = rowA.PrecioOferta > 0 ? rowA.PrecioOferta : rowA.PrecioLista || 0;
        const priceB = rowB.PrecioOferta > 0 ? rowB.PrecioOferta : rowB.PrecioLista || 0;
        return priceA - priceB;
      },
    },
    {
      name: <div style={{ textAlign: 'right', width: '100%' }}>Stock</div>,
      width: configEcommerce?.con_sin_stock ? '150px' : '88px',
      selector: row => Number(row.Stock) || 0,
      cell: row => (
        <div
          style={{
            textAlign: 'right',
            width: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
          }}
        >
          {configEcommerce?.ocultar_stock || Number(row.ocultar_stock) === 1 ? (
          <PriceConsultationButton
            className="stock-oculto rounded bg-amber-100 px-2 py-1 text-xs font-bold"
            modalTitle="Stock a consultar"
          >
            {row.ocultar_stock_texto || "Stock a consultar"}
          </PriceConsultationButton>
          ) : (
            <>
              {configEcommerce?.con_sin_stock && row.stock_mensaje ? (
                mostrarStockYMensaje ? (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "flex-end",
                      lineHeight: "1.2",
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 700,
                      }}
                    >
                      {parseInt(row.Stock, 10)}
                    </span>

                    <span
                      style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "4px",
                        color: getStockMessageColor(row.stock_mensaje),
                        fontWeight: 600,
                        fontSize: "11px",
                      }}
                    >
                      <FaLightbulb style={{ flexShrink: 0 }} />
                      <span>{row.stock_mensaje}</span>
                    </span>
                  </div>
                ) : (
                  <span
                    style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      gap: "4px",
                      color: getStockMessageColor(row.stock_mensaje),
                      fontWeight: 600,
                    }}
                  >
                    <FaLightbulb style={{ flexShrink: 0 }} />
                    <span>{row.stock_mensaje}</span>
                  </span>
                )
              ) : (
                <span>{parseInt(row.Stock, 10)}</span>
              )}

              {parseInt(row.Stock, 10) <= 0 && (
                <FaBell
                  title='Notificarme Ingreso de Stock'
                  style={{
                    fontSize: '12px',
                    cursor: 'pointer',
                    marginLeft: '8px',
                    color: '#FFCC00',
                  }}
                  onClick={() => handleStockAlertClick(row.codigo)}
                />
              )}
            </>
          )}
        </div>
      ),
      sortable: true,
      sortFunction: (rowA, rowB) => {
        const stockA = Number(rowA.Stock) || 0;
        const stockB = Number(rowB.Stock) || 0;
        return stockA - stockB;
      },
    },
    {
      name: 'Condicion',
      width: '112px',
      selector: row => row.atributo,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Grupo',
      width: '112px',
      selector: row => row.grupo,
      sortable: true,
      wrap: true,
    },
    {
      name: 'Marca',
      width: '112px',
      selector: row => row.marca,
      sortable: true,
      wrap: true,
    },
    ...(isNewsPage
      ? []
      : [
        {
          name: 'Cantidad',
          width: '90px',
          cell: row => (
            <input
              type="number"
              id={`quantity-input-${row.codigo}`}
              min="0"
              max={Math.max(0, Number(row.Stock) || 0)}
              value={quantities[row.codigo] || 0}
              onChange={e => handleQuantityChangeInternal(row.codigo, e.target.value)}
              className="w-10 border border-gray-300 rounded text-right"
              style={{ fontSize: '10px', textAlign: 'right' }}
            />
          ),
          ignoreRowClick: true,
        },
        {
          name: 'Acciones',
          width: '110px',
          cell: row => {
            return (
              <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                <button
                  onClick={() => configEcommerce?.ocultar_precio || Number(row.ocultar_precio) === 1
                    ? showPriceConsultationModal()
                    : handleAddToCartInternal(row)}
                  className="bg-blue-500 text-white px-1 py-0.5 rounded hover:bg-blue-700"
                  style={{ fontSize: '15px' }}
                  title={configEcommerce?.ocultar_precio || Number(row.ocultar_precio) === 1 ? "Consultar precio" : "Agregar"}
                >
                  <FaShoppingCart />
                </button>

                <button
                  onClick={() => handleRelacionar(row)}
                  className="bg-green-500 text-white px-1 py-0.5 rounded hover:bg-green-700"
                  style={{ fontSize: '15px' }}
                  title="Productos Relacionados"
                >
                  <FaCircleNodes />
                </button>

                <button
                  onClick={() => handlProdxCant(row)}
                  className="bg-orange-500 text-white px-1 py-0.5 rounded hover:bg-green-700"
                  style={{ fontSize: '15px' }}
                  title="Descuento por Cantidad"
                >
                  <FaCircleDollarToSlot />
                </button>
              </div>
            );
          },
          ignoreRowClick: true,
        },
      ]),
  ];

  const filteredProducts = products.filter((item) => {
    const texto = search.toLowerCase();

    return (
      item.codigo?.toLowerCase().includes(texto) ||
      item.Descripcion?.toLowerCase().includes(texto) ||
      item.grupo?.toLowerCase().includes(texto) ||
      item.marca?.toLowerCase().includes(texto) ||
      item.atributo?.toLowerCase().includes(texto) ||
      item.stock_mensaje?.toLowerCase().includes(texto)
    );
  });

  return (
    <>
      <div className="mb-2">
        <input
          type="text"
          placeholder="Buscar en la Grilla ..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className="border rounded-md px-3 py-2 w-full text-sm"
        />
      </div>

      <DataTable
        columns={columns}
        data={filteredProducts}
        conditionalRowStyles={[
          {
            when: row => row.color_oferta && row.color_oferta !== '',
            style: row => ({
              backgroundColor: row.color_oferta,
              color: '#fff', // opcional, por si el fondo es oscuro
            }),
          },
        ]}
        customStyles={{
          rows: {
            style: {
              minHeight: '50px',
            },
          },
          headCells: {
            style: {
              fontSize: '12px',
              fontWeight: 'bold',
              paddingLeft: '6px',
              paddingRight: '6px',
              backgroundColor: '#f1f3f5',
            },
          },
          cells: {
            style: {
              fontSize: '11px',
              paddingLeft: '6px',
              paddingRight: '6px',
              whiteSpace: 'normal',
              overflow: 'visible',
              alignItems: 'stretch',
            },
          },
        }}
      />

      {/* Modal Relacionar */}
      {showRelacionarModal && selectedRow && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[92vw] max-w-[920px] p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Relacionar Productos</h2>
              <button
                onClick={() => setShowRelacionarModal(false)}
                className="text-gray-600 hover:text-red-600 text-xl font-bold"
              >
                X
              </button>
            </div>

            <div className="max-h-[80vh] overflow-y-auto p-6">
              {/* Datos del producto seleccionado */}

              {canManageRelations && (
                <div className="mb-6 rounded-lg border border-gray-200 bg-white p-3">
                  <label className="block text-sm font-semibold text-gray-700">
                    Buscar producto para relacionar
                  </label>
                  <input
                    type="text"
                    value={relacionSearchTerm}
                    onChange={(e) => setRelacionSearchTerm(e.target.value)}
                    placeholder="Codigo o descripcion..."
                    className="mt-2 w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-400 focus:ring-2 focus:ring-blue-100"
                  />

                  <div className="mt-3 max-h-56 overflow-y-auto">
                    {loadingRelacionSearch ? (
                      <p className="py-3 text-center text-sm text-gray-400">Buscando productos...</p>
                    ) : relacionSearchTerm.trim().length > 1 && relacionResults.length === 0 ? (
                      <p className="py-3 text-center text-sm text-gray-400">No se encontraron productos.</p>
                    ) : (
                      relacionResults.map((product) => (
                        <button
                          key={product.codigo}
                          type="button"
                          onClick={() => handleSelectRelacionado(product)}
                          className="mb-2 flex w-full items-center gap-3 rounded-lg border border-gray-100 p-2 text-left transition hover:border-blue-200 hover:bg-blue-50"
                        >
                          <img
                            src={product.img}
                            alt={product.Descripcion}
                            className="h-10 w-10 shrink-0 object-contain"
                          />
                          <span className="min-w-0">
                            <span className="block text-[11px] font-semibold text-gray-500">{product.codigo}</span>
                            <span className="block truncate text-xs text-gray-800">{product.Descripcion}</span>
                          </span>
                        </button>
                      ))
                    )}
                  </div>
                </div>
              )}

              <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                <p className="text-sm font-medium text-gray-700">{selectedRow.codigo}</p>
                <p className="text-sm text-gray-500">{selectedRow.Descripcion}</p>
              </div>


              {/* Timeline de seguimiento (si existe) */}
              {Array.isArray(selectedRow.productos_relacionados) && selectedRow.productos_relacionados.length > 0 ? (
                <div className="relative border-l border-gray-300 ml-4">
                  {selectedRow.productos_relacionados.map((relacion, index) => (
                    <div key={index} className="relative mb-2 ml-4 flex items-start justify-between gap-3 rounded-lg border border-gray-100 bg-white px-3 py-2">
                      <div className="absolute left-[-22px] top-3 h-2.5 w-2.5 rounded-full border border-white bg-blue-600"></div>
                      <div className="min-w-0">
                        <p className="text-[10px] font-semibold leading-4 text-gray-500">{relacion.codigo}</p>
                        <h3 className="truncate text-[11px] font-medium leading-4 text-gray-800">
                          {relacion.Descripcion}
                        </h3>
                      </div>
                      {canManageRelations && (
                        <button
                          type="button"
                          onClick={() => handleDeleteRelacionado(relacion)}
                          className="flex h-7 w-7 shrink-0 items-center justify-center rounded-md text-red-500 transition hover:bg-red-50 hover:text-red-700"
                          title="Eliminar relacion"
                        >
                          <FaTrash className="text-[11px]" />
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400 text-center">No tiene productos relacionados.</p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Modal Prod x Cant */}
      {showProdxCantModal && selectedRow && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-2xl shadow-lg w-[92vw] max-w-[920px] p-6">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-xl font-semibold">Descuento por Cantidad</h2>
              <button
                onClick={() => setShowProdxCantModal(false)}
                className="text-gray-600 hover:text-red-600 text-xl font-bold"
              >
                X
              </button>
            </div>

            <div className="max-h-[80vh] overflow-y-auto p-6">
              {/* Descuentos del producto seleccionado */}

              <div className="mb-4 p-3 bg-gray-50 rounded-lg">
                <p className="text-sm font-medium text-gray-700">{selectedRow.codigo}</p>
                <p className="text-sm text-gray-500">{selectedRow.Descripcion}</p>
              </div>

              {/* Timeline de seguimiento (si existe) */}
              {Array.isArray(selectedRow.productos_desc_x_cant) && selectedRow.productos_desc_x_cant.length > 0 ? (
                <div className="relative border-l border-gray-300 ml-4">
                  {selectedRow.productos_desc_x_cant.map((relacion, index) => (
                    <table className="w-full border-collapse border border-gray-300 mt-4">
                      <thead>
                        <tr className="bg-gray-100">
                          <th className="border p-2 text-right">Cantidad Desde</th>
                          <th className="border p-2 text-right">Descuento</th>
                          <th className="border p-2 text-right">Fecha Hasta</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedRow.productos_desc_x_cant.map((item, index) => (
                          <tr key={index} className="small">
                            <td className="border p-2 text-right">
                              {item.cantidad_desde}
                            </td>
                            <td className="border p-2 text-right">
                              {item.descuento}%
                            </td>
                            <td className="border p-2 text-right">
                              {new Date(item.fecha_hasta).toLocaleDateString("es-AR")}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ))}
                </div>
              ) : (
                <p className="text-sm text-gray-400 text-center">No tiene Descuentos por Cantidad.</p>
              )}
            </div>
          </div>
        </div>
      )}

    </>

  );
};

export default ProductTable;





